var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.visibleSections),function(section){return _c('flight-bookings-list',{key:section.title,attrs:{"title":section.title,"filters":section.filters,"hide-empty":section.hideEmpty,"page-size":10}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }